import Post from '~/repository/models/Post';
import type {Profile} from "~/repository/types";

const postIdGenerator = (profileID: number) => (id: number) => `profile-${profileID}-feed-post-${id}`;

export const useProfileFeedAPI = (profile: Profile) => {
    const {$api} = useNuxtApp();
    const newPostState = useState<Post>('newPost')

    watch(newPostState, (value: Post) => {
        posts.value = {
            ...groupById([new Post(value)], postIdGenerator(profile.id)),
            ...posts.value
        }
    })

    const posts = useState<{ [key: string]: Post }>(`profile-${profile.id}-posts`, () => ({}));

    const fetch = async () => await $api.posts.getProfilePosts(profile.username, currentPage.value).then((paginatedData) => {
        const transformedData = {
            ...paginatedData,
            data: paginatedData.data.map(post => new Post(post))
        };
        posts.value = {
            ...posts.value,
            ...groupById(transformedData.data, postIdGenerator(profile.id)),
        };
        lastPage.value = transformedData.meta.last_page;
    })

    const {
        loadMoreElement,
        currentPage,
        lastPage,
        isFetching,
        fetchNextPage,
        firstFetch,
        canGoNextPage
    } = useInfinityScroll(fetch, 0)

    function forgetPost(post: Post) {
        if (posts.value && posts.value[postIdGenerator(profile.id)(post.id)]) {
            delete posts.value[postIdGenerator(profile.id)(post.id)];
        }
    }

    return {
        loadMoreElement,
        posts,
        fetching: isFetching,
        canGoNextPage,
        fetchNextPage,
        lastPage,
        firstFetch,
        fetch,
        forgetPost
    };
};
